import React from "react"
import { Div, Text } from "atomize"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus } from "@fortawesome/free-solid-svg-icons"
import { motion } from "framer-motion"
import { theme } from "../settings/config"
import DashedOutline from "./DashedOutline"

// Interruttore a pastiglia: acceso è pieno, spento è tratteggiato col più.
// Serve dove le scelte sono tante e indipendenti — metodi di pagamento,
// tipi di lezione, sport da aggiungere — e il tratteggio dice "questo si
// può accendere" senza bisogno di spiegarlo.
const SIZES = {
	md: { p: "0.4rem 0.9rem", textSize: "body" },
	lg: { p: "0.6rem 1.2rem", textSize: "subheader" },
}

function ToggleChip({ text, isSelected, color, onClick, size = "md" }) {
	const activeColor = color ?? theme.colors.gunmetal_fill
	const { p, textSize } = SIZES[size] ?? SIZES.md

	return (
		<motion.div whileTap={{ scale: 0.95 }}>
			<Div
				d="flex"
				align="center"
				p={p}
				w="fit-content"
				rounded="20px"
				cursor="pointer"
				transition
				// il bordo resta, trasparente da spenta: accendendola la pastiglia
				// non cambia misura
				border="2px solid"
				borderColor={isSelected ? activeColor : "transparent"}
				bg={isSelected ? activeColor : "transparent"}
				pos="relative"
				style={{ gap: "0.4rem" }}
				onClick={onClick}>
				{!isSelected && (
					<DashedOutline color={theme.colors.gray_light} width={2} radius={20} over={2} />
				)}
				{!isSelected && (
					<FontAwesomeIcon icon={faPlus} color={theme.colors.text_light} size="xs" />
				)}
				<Text
					textSize={textSize}
					textWeight={isSelected ? "bold" : "normal"}
					textColor={isSelected ? theme.colors.white : theme.colors.text_light}
					style={{ whiteSpace: "nowrap" }}>
					{text}
				</Text>
			</Div>
		</motion.div>
	)
}

export default ToggleChip
